<script>
	import {LayoutDirs, ButtonSizeTypes, ButtonTypes} from '../../../../enum'
	import HoriLayout from '../../../container/layout/col/Index.vue'
	import VertLayout from '../../../container/layout/row/Index.vue'
	import Checkbox from '../checkbox/Index.vue'
	
	export default {
		name: 'group-buttons',
		
		props: {
			items: {
				type: Array,
				default(){
					return []
				}
			},
			
			align: {
				type: String,
				default: 'right'
			},
			
			valign: {
				type: String,
				default: 'middle'
			},
			
			itemHeight: {
				type: [String, Number],
				default: 'auto'
			},
			
			itemWidth: {
				type: [String, Number],
				default: '100%'
			},
			
			value: {
				type: [String, Number],
				default: ''
			},
			
			type: {
				type: String,
				default: 'normal'
			},
			
			dir: {
				type: String,
				default: LayoutDirs.HORI
			}
		},
		
		render(c){
			const layouter = this.dir.toUpperCase() === LayoutDirs.HORI ? HoriLayout : VertLayout
			return c(layouter, {
				props: {
					width: this.dir.toUpperCase() === LayoutDirs.HORI ? 'auto' : '100%',
					height: 'auto',
					valign: this.valign,
					align: this.align,
					wrap: true
				},
				class: 'auto-fill'
			}, this.values.map(({text, code, chose}) => {
				return c(Checkbox, {
					props: {
						type: this.type,
						value: chose,
						label: text,
						width: this.itemWidth,
						height: this.itemHeight
					},
					on: {
						click: () => {
							this.$emit('input', code)
						}
					}
				})
			}))
		},
		
		computed: {
			values(){
				return this.items.map(item => {
					item.chose = item.code === this.value
					return item
				})
			}
		}
	}
</script>

<style>
</style>
